module.exports = __webpack_public_path__ + "img/edit.d9680e0c.png";